function createStorage(getNativeStorage: () => Storage): Storage {
  try {
    const nativeStorage = getNativeStorage()
    const testKey = "__storage_test__"
    nativeStorage.setItem(testKey, "test")
    nativeStorage.removeItem(testKey)
    return nativeStorage
  } catch {
    // In-Memory Fallback wenn der native Storage blockiert ist (z.B. iFrame mit Datenschutzeinstellungen)
    // Einmaliger Hinweis (createStorage läuft genau einmal beim Modul-Import):
    // ohne Storage überleben Login und Buchungsdaten keinen Seiten-Reload.
    console.warn(
        "[safeStorage] localStorage ist nicht verfügbar (z.B. Inkognito-Modus oder blockierte Third-Party-Cookies im iFrame) — es wird ein In-Memory-Fallback verwendet. Login und Buchungsdaten gehen bei einem Seiten-Reload verloren."
    )
    const store = new Map<string, string>()
    return {
      getItem: (key) => store.get(key) ?? null,
      setItem: (key, value) => store.set(key, String(value)),
      removeItem: (key) => { store.delete(key) },
      clear: () => store.clear(),
      get length() { return store.size },
      key: (index) => [...store.keys()][index] ?? null,
    } as Storage
  }
}

export const safeStorage = createStorage(() => window.localStorage)

export const safeSessionStorage = createStorage(() => window.sessionStorage)
